import { render, staticRenderFns } from "./detailIcon.vue?vue&type=template&id=6ec1ee4e&"
import script from "./detailIcon.vue?vue&type=script&lang=js&"
export * from "./detailIcon.vue?vue&type=script&lang=js&"
import style0 from "./detailIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports